<!-- qa问题搜索有结果 -->
<template>
  <div>
    <headBar />
    <searchModel />
    <div class="backGroundBg">
      <div class="con">
        <div class="backHomg">{{ helpCenterLabel }}</div>
        <div class="searchConBox">
          <leftMenu />
          <div class="searchBoxRight">
            <h1>{{ resultsForLabel }} {{ searchText }}</h1>
            <div class="divider"></div>
            <ul class="answerList">
              <li
                v-for="(searchItem, searchIndex) in showList"
                :key="searchIndex"
              >
                <h2>
                  <span
                    @click="$fun.routerToPage('/' + searchItem.router)"
                    v-html="searchItem.title"
                  ></span>
                </h2>
                <p><span v-html="searchItem.answer"></span>[…]</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <contactUs />
    <footbar />
  </div>
</template>
<script>
import headBar from "../../../components/head/HomePageTop.vue";
import leftMenu from "./components/leftMenu.vue";
import footbar from "../../../components/foot/Foot.vue";
import searchModel from "./components/searchModel.vue";
import pageData from "./unitl/pageData";
import contactUs from "./components/contactUs.vue";
import {
  resolveFaqPages,
  searchFaqPages,
  getFaqLabel,
} from "./unitl/faqLocale";

export default {
  data() {
    return {
      pageData,
      showList: [],
    };
  },
  components: {
    headBar,
    footbar,
    searchModel,
    leftMenu,
    contactUs,
  },
  computed: {
    homePage() {
      return pageData.find((item) => item.router === "centro-de-ayuda") || {};
    },
    helpCenterLabel() {
      return getFaqLabel(
        this.homePage.uiLabels,
        "helpCenter",
        this.$store.state.fanyi,
      );
    },
    resultsForLabel() {
      return getFaqLabel(
        this.homePage.uiLabels,
        "resultsFor",
        this.$store.state.fanyi,
      );
    },
    searchText() {
      const raw = this.$route.query.s || "";
      return decodeURIComponent(String(raw).replace(/\+/g, " "));
    },
  },
  watch: {
    "$route.query.s"() {
      this.getSearchList();
    },
    "$store.state.fanyi"() {
      this.getSearchList();
    },
  },
  mounted() {
    this.getSearchList();
  },
  methods: {
    getSearchList() {
      const query = this.searchText.trim();
      if (!query) {
        this.showList = [];
        return;
      }
      this.showList = resolveFaqPages(
        searchFaqPages(pageData, query),
        this.$store.state.fanyi,
      );
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.backGroundBg {
  background-color: white;
  padding-top: 20px;
  .con {
    width: 1000px;
    margin: 0 auto;
    .backHomg {
      font-size: 14px;
      color: #7a7a7a;
      padding: 10px 10px 24px;
    }
    .searchConBox {
      display: flex;
      .searchBoxRight {
        flex: 1;
        padding: 10px;
        h1 {
          font-size: 26px;
          font-weight: 500;
          line-height: 1;
          margin-bottom: 20px;
        }
        .divider {
          height: 1px;
          background-color: #d5d5d5;
          margin-bottom: 20px;
        }
        .answerList {
          h2 {
            margin-bottom: 20px;
            /deep/span {
              font-weight: 500;
              line-height: 1;
              color: inherit;
              font-size: 26px;
              cursor: pointer;
              color: #009246;
              &:hover {
                color: black;
              }
            }
          }
          p,
          /deep/p {
            margin-bottom: 30px;
            font-size: 15px;
            line-height: 1.8em;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            * {
              display: inline;
            }
            b {
              font-weight: normal;
            }
            /deep/ a,
            /deep/ .cuGreenLink,
            /deep/ .blurLink {
              color: #06ac1c;
              font-weight: 600;
              text-decoration: underline;

              &:hover {
                color: #009246;
              }
            }
            /deep/ .cuGreenLink {
              text-decoration: none;

              u {
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
  }
}
</style>
